/** @format */

import { Component, input, output, computed, Signal } from '@angular/core';
import { HmfCheckboxComponent } from '@dsg-tech/homefield-angular';
import { HomefieldColorSwatchModule } from '@homefield';
import { GTGT_FILTER_NAME } from '@plp/data-access/constants';
import { CategoryDetails, FacetVOValue } from '@plp/data-access/interfaces';

@Component({
	selector: 'plp-components-filter-option',
	templateUrl: './filter-option.component.html',
	styleUrls: ['./filter-option.component.scss'],
	imports: [HmfCheckboxComponent, HomefieldColorSwatchModule]
})
export class FilterOptionComponent {
	readonly attributeIdentifier = input.required<string>();
	readonly attributeName = input.required<string>();
	readonly filterOption = input.required<FacetVOValue>();
	readonly isMobile = input(false);
	readonly disabled = input(false);
	readonly selectedOptions = input<string[]>([]);
	readonly isCategoryFilter = input(false);
	readonly isPriceFilter = input(false);
	readonly isFirst = input(false);
	readonly displayText = input<Record<string, string> | null>(null);
	readonly categoryDetails = input<CategoryDetails | null>(null);

	GTGT_FILTER_NAME = GTGT_FILTER_NAME;
	MULTICOLOR_IMAGE =
		'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAIAAACZeshMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHxJREFUeNpifCuvwoAEuMp/IXNNNjYgc1/aLkbmMjFQAIaoZsZL2XnI/KO3UKQN8/cic536viFzWZ54eyLzH+y/hMxNVbmJzP22788wCDAWhe8cyPzHpnLI3PtvUEJETX4fimb5b+zIfM0FEcjcXRvfI3NV5U+O9OQJEGAAwBofdtN6GyIAAAAASUVORK5CYII=';

	setSelectedFilter = output<string>();
	setSelectedFilterWithSpace = output<{ event: KeyboardEvent; value: string }>();

	readonly checked: Signal<boolean> = computed(() =>
		this.selectedOptions().includes(this.filterOption().value)
	);

	readonly ariaLabel: Signal<string> = computed(() => {
		if (this.isCategoryFilter()) {
			return `${this.categoryDetails()?.[this.filterOption().value]?.name}. ${this.filterOption().count} products. ${this.selectedOptions().includes(this.filterOption().value) ? 'selected' : 'not selected'}`;
		} else if (this.isPriceFilter() || this.attributeName() === GTGT_FILTER_NAME) {
			return this.displayText()?.[this.filterOption().value];
		} else {
			return `${this.filterOption().value}, ${this.filterOption().count} products`;
		}
	});

	readonly displayValue: Signal<string> = computed(() => {
		if (this.isPriceFilter() || this.attributeName() === GTGT_FILTER_NAME) {
			return this.displayText()?.[this.filterOption().value];
		} else if (this.isCategoryFilter()) {
			return this.categoryDetails()?.[this.filterOption().value]?.name;
		} else {
			return this.filterOption().value;
		}
	});

	handleSpace(event: KeyboardEvent): void {
		this.setSelectedFilterWithSpace.emit({ event, value: this.filterOption().value });
	}

	handleClick(): void {
		this.setSelectedFilter.emit(this.filterOption().value);
	}
}
